import { initSgBootstrap } from '@/utils/theme.ts';

initSgBootstrap();
